
export function ItemFormsNextIndex() {
  const inputs = document.querySelectorAll('input[name*="item_counter"]')
  if (inputs.length === 0) return 0

  return Math.max(...Array.from(inputs).map(input => parseInt(input.value, 10))) + 1
}

export function MaxDataIndex(selector) {
  const elements = document.querySelectorAll(selector)
  if (elements.length === 0) return 0

  return Math.max(...Array.from(elements).map(el => parseInt(el.dataset.index, 10))) + 1
}
